import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { Grid, Header, Segment } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { CoolFarmCropOptionsContext } from '../../index'
import { useTranslation } from 'react-i18next'
import IrrigationEventsTable from './IrrigationEventsTable'

const Irrigation: React.FC = () => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const options = useContext(CoolFarmCropOptionsContext)

  const irrigationMethodOptions = options?.irrigationMethods?.map(method => ({
    key: method.key,
    value: method.key,
    text: method.label
  })) || []

  const waterSourceOptions = options?.irrigationWaterSources?.map(source => ({
    key: source.key,
    value: source.key,
    text: source.label
  })) || []

  const powerSourceOptions = options?.irrigationPowerSources?.map(source => ({
    key: source.key,
    value: source.key,
    text: source.label
  })) || []

  const depthUnitOptions = options?.irrigationDepthUnits?.map(unit => ({
    key: unit.key,
    value: unit.key,
    text: unit.label
  })) || []

  const distanceUnitOptions = options?.irrigationDistanceUnits?.map(unit => ({
    key: unit.key,
    value: unit.key,
    text: unit.label
  })) || []

  const waterUnitOptions = options?.irrigationAllocatedWaterUnits?.map(unit => ({
    key: unit.key,
    value: unit.key,
    text: unit.label
  })) || []

  const emissionsBasedOnOptions = options?.irrigationCalculationTypes?.map(option => ({
    key: option.key,
    value: option.key,
    text: option.label
  })) || []

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={16}>
          <Header attached='top' block>
            {t('Irrigation Events')}
          </Header>
          <Segment attached>
            <Grid>
              <Grid.Row>
                <Grid.Column width={6}>
                  <FormFields.Select
                    control={control}
                    name='irrigationCalculationType'
                    label={t('Emissions based on')}
                    withoutAsterisk
                    rules={{
                      required: true
                    }}
                    options={emissionsBasedOnOptions}
                    placeholder={t('Select emissions basis')}
                    noErrorMessage
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <FormFields.Input
                    control={control}
                    name='numberOfIrrigationEvents'
                    withoutAsterisk
                    label={t('Events')}
                    placeholder={t('Number')}
                    typeInput='controled'
                    noErrorMessage
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <FormFields.Select
                    control={control}
                    name='defaultIrrigationMethod'
                    label={t('Method')}
                    clearable
                    withoutAsterisk
                    options={irrigationMethodOptions}
                    placeholder={t('Select irrigation method')}
                    noErrorMessage
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={16}>
                  <Header as='h4'>{t('Default water source and water pumping parameters')}</Header>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={8}>
                  <FormFields.Select
                    control={control}
                    name='defaultIrrigationWaterSource'
                    label={t('Water source')}
                    withoutAsterisk
                    options={waterSourceOptions}
                    placeholder={t('Select water source')}
                    noErrorMessage
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={8}>
                  <FormFields.Input
                    control={control}
                    name='defaultIrrigationDepth'
                    withoutAsterisk
                    label={t('Pumping depth')}
                    placeholder={t('Enter depth')}
                    typeInput='controled'
                    noErrorMessage
                  />
                </Grid.Column>
                <Grid.Column width={8}>
                  <FormFields.Select
                    control={control}
                    name='defaultIrrigationDepthUnit'
                    clearable
                    label={t('Unit')}
                    withoutAsterisk
                    options={depthUnitOptions}
                    placeholder={t('Select unit')}
                    noErrorMessage
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={8}>
                  <FormFields.Input
                    control={control}
                    name='defaultIrrigationDistance'
                    withoutAsterisk
                    clearable
                    label={t('Horizontal distance')}
                    placeholder={t('Enter distance')}
                    typeInput='controled'
                    noErrorMessage
                  />
                </Grid.Column>
                <Grid.Column width={8}>
                  <FormFields.Select
                    control={control}
                    name='defaultIrrigationDistanceUnit'
                    label={t('Unit')}
                    withoutAsterisk
                    options={distanceUnitOptions}
                    clearable
                    placeholder={t('Select unit')}
                    noErrorMessage
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={8}>
                  <FormFields.Select
                    control={control}
                    name='defaultIrrigationPowerSource'
                    label={t('Power source')}
                    withoutAsterisk
                    options={powerSourceOptions}
                    clearable
                    placeholder={t('Select power source')}
                    noErrorMessage
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </Grid.Column>
      </Grid.Row>

      <IrrigationEventsTable
        waterUnitOptions={waterUnitOptions}
        waterSourceOptions={waterSourceOptions}
        powerSourceOptions={powerSourceOptions}
        depthUnitOptions={depthUnitOptions}
        distanceUnitOptions={distanceUnitOptions}
      />
    </Grid>
  )
}

export default Irrigation
